import React from 'react';
import Pills from '../../../Pills/Pill';
import Tooltip from '../../../Tooltip/Tooltip';
import Icon from '../../../Icon2/Icon';
import {
  ASSET_SCAN_STATUSES,
  DISPLAY_LABELS,
  TOOLTIP_CONTENT,
  PILL_BACKGROUND,
} from '../../utils/constants';

export type AssetScanStatusProps = {
  isDir?: boolean | undefined,
  assetScanStatus: string | undefined;
};

export const getLeadingIcon = (scanStatus: string) => {
  if (scanStatus === ASSET_SCAN_STATUSES.CLEAN) {
    return (
      <Icon
        icon="CheckCircle"
        version="v2"
        width={20}
        height={20}
        className="info-icon"
        data-test-id="asset-scan-status-pill-icon-clean"
      />
    );
  }
  if (scanStatus === ASSET_SCAN_STATUSES.QUARANTINED) {
    return (
      <Icon
        icon="WarningBoldNew"
        version="v2"
        width={20}
        height={20}
        className="info-icon"
        data-test-id="asset-scan-status-pill-icon-quarantined"
      />
    );
  }
  if (scanStatus === ASSET_SCAN_STATUSES.PENDING) {
    return (
      <Icon
        icon="Clock"
        version="v2"
        width={20}
        height={20}
        className="info-icon"
        data-test-id="asset-scan-status-pill-icon-pending"
      />
    );
  }
  return undefined;
};

const AssetScanStatusPill: React.FC<AssetScanStatusProps> = ({ isDir, assetScanStatus }) => {
  if (!assetScanStatus || assetScanStatus === ASSET_SCAN_STATUSES.NOT_SCANNED) {
    return <div className="noStatus">{ isDir ? "-" : "Not Scanned" }</div>;
  }

  const scanStatusLabel = DISPLAY_LABELS[assetScanStatus];

  const itemPills = [
    {
      id: '1',
      text: scanStatusLabel,
      leadingIcon: getLeadingIcon(assetScanStatus),
    },
  ];

  return (
    <div className="asset-scan-status-cell">
      <Tooltip
        appendTo={document.body}
        position="bottom"
        showArrow={false}
        content={TOOLTIP_CONTENT[assetScanStatus]}
        style={{ paddingBottom: '0px' }}
        data-test-id="asset-scan-status-tooltip"
      >
        <Pills
          variant="chip"
          stroke="#6E6B86"
          background={PILL_BACKGROUND[assetScanStatus]}
          shouldHaveBorder={false}
          items={itemPills}
          testId="asset-scan-status-pills"
        />
      </Tooltip>
    </div>
  );
};

export default AssetScanStatusPill;